import {Box, Flex, Image, Text} from '@chakra-ui/react'
import Volume from '@assets/svgs/gym/volume.svg'
import MicIcon from '@assets/svgs/mic.svg'
import Lottie from 'lottie-react'
import * as animationData from '@assets/lotties/mic.json'
import {useEffect, useState} from 'react'
import {useAudioRecorder} from 'react-audio-voice-recorder'
import gymRequest from '@apis/gym'
import {Progress as ProgressAnt} from 'antd'
import {IDataSpeech} from '@components/GlobalTrans/GlobalTransModel'
import {
  updatePronounceDataSpeech,
  updatePairDataSpeech,
  updatePracticeDataSpeech,
  upDateTotalPronounceRecording,
  upDateTotalPairRecording,
  upDateTotalPracticeRecording,
  upDateIsGoodRecording,
} from '@redux/gym/gymSlice'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'

const MicCard = ({
  data,
  setIsFinish,
  setIsPlayingVideo,
}: {
  data: any
  setIsFinish: any
  setIsPlayingVideo: any
}) => {
  const stateGym = useSelector((state: any) => state.gym)
  const location = useLocation()
  const type = location?.state?.type
  const [dataSpeech, setDataSpeech] = useState<IDataSpeech>()
  const {startRecording, stopRecording, recordingBlob, isRecording} =
    useAudioRecorder()
  const dispatch = useDispatch()

  useEffect(() => {
    setDataSpeech(undefined)
  }, [data])

  useEffect(() => {
    if (stateGym.pairDataSpeech.length === 2) {
      setIsFinish(true)
    }
  }, [stateGym.pairDataSpeech])

  useEffect(() => {
    if (!recordingBlob) {
      return
    }

    let file = new File([recordingBlob], 'audio.wav', {type: 'audio/wav'})
    const formData = new FormData()
    formData.append('audio-file', file)
    formData.append('text-refs', data?.data?.word || data?.data?.check_word)
    gymRequest.getSpeechCheck(formData).then((res: any) => {
      if (res?.data && res.data?.data) {
        const score = Math.round(Number(res.data?.data?.total_score) * 100)
        setDataSpeech(res.data?.data)
        switch (type) {
          case 'HOC_PHAT_AM':
            dispatch(updatePronounceDataSpeech(res.data?.data))
            dispatch(
              upDateTotalPronounceRecording(
                stateGym.totalPronounceRecording + 1,
              ),
            )
            if (
              (res.data?.data && score >= 75) ||
              (stateGym.totalPronounceRecording >= 1 && score >= 30) ||
              (stateGym.totalPronounceRecording >= 2 && score >= 0)
            ) {
              if (score < 75) {
                dispatch(upDateIsGoodRecording(false))
              } else {
                dispatch(upDateIsGoodRecording(true))
              }
              setIsFinish(true)
            }
            break
          case 'CAP_TU':
            const checkExist = stateGym.pairDataSpeech.find(
              (item: any) => item.text_refs === res.data?.data?.text_refs,
            )
            const newTotalPairRecording = {
              ...stateGym?.totalPairRecording,
              [res.data?.data?.text_refs]: stateGym?.totalPairRecording[
                res.data?.data?.text_refs
              ]
                ? stateGym?.totalPairRecording[res.data?.data?.text_refs] + 1
                : 1,
            }
            dispatch(upDateTotalPairRecording(newTotalPairRecording))

            if (
              (score >= 75 && !checkExist) ||
              (score >= 30 &&
                !checkExist &&
                stateGym?.totalPairRecording[res.data?.data?.text_refs] == 1) ||
              (!checkExist &&
                stateGym?.totalPairRecording[res.data?.data?.text_refs] == 2)
            ) {
              if (score < 75) {
                dispatch(upDateIsGoodRecording(false))
              } else {
                dispatch(upDateIsGoodRecording(true))
              }
              const newData = [...stateGym.pairDataSpeech, res.data?.data]
              dispatch(updatePairDataSpeech(newData))
            }
            break
          case 'LUYEN_TAP':
            dispatch(updatePracticeDataSpeech(res.data?.data))
            dispatch(
              upDateTotalPracticeRecording(stateGym.totalPracticeRecording + 1),
            )
            if (
              (res.data?.data && score >= 75) ||
              (stateGym.totalPracticeRecording >= 1 && score >= 30) ||
              (stateGym.totalPracticeRecording >= 2 && score >= 0)
            ) {
              if (score < 75) {
                dispatch(upDateIsGoodRecording(false))
              } else {
                dispatch(upDateIsGoodRecording(true))
              }
              setIsFinish(true)
            }
            break
          default:
            break
        }
      }
    })
  }, [recordingBlob])

  const getScore = (value: any) => {
    const score = Math.round(Number(value) * 100)
    return score
  }

  const getStrokeColor = (score: any) => {
    if (score < 50) {
      return '#E55856'
    } else if (score < 75) {
      return '#FFCD00'
    } else {
      return '#6AC985'
    }
  }

  const getTrailColor = (score: any) => {
    if (score < 50) {
      return '#FADEDD'
    } else if (score < 75) {
      return '#FFF5CC'
    } else {
      return '#DAF1E0'
    }
  }

  const getColorCharacters = (phoneIpa: any, checkIpa: any) => {
    if (`/${phoneIpa?.phone_ipa}/` === checkIpa) {
      if (getScore(dataSpeech?.total_score) < 50) {
        return '#E55856'
      } else if (getScore(dataSpeech?.total_score) < 75) {
        return '#FFCD00'
      } else {
        return '#6AC985'
      }
    }
    return ''
  }

  const handleReplay = () => {
    if (setIsPlayingVideo) {
      setIsPlayingVideo(false)
    }
    const audio = new Audio(data?.audio_path)
    audio.play()
  }

  const handleRecording = async () => {
    if (setIsPlayingVideo) {
      setIsPlayingVideo(false)
    }
    if (isRecording) {
      stopRecording()
    } else {
      startRecording()
    }
  }

  return (
    <Box boxShadow={'0px 0px 8px 2px #ccc'} borderRadius={'16px'} mt={'24px'}>
      <Box p={'32px'} position={'relative'}>
        <Flex
          position={'absolute'}
          top={'16px'}
          left={'16px'}
          w={'40px'}
          h={'40px'}
          justifyContent={'center'}
          align={'center'}
          bg={'#D1E9FF'}
          borderRadius={'50%'}
          cursor={'pointer'}
          _hover={{bg: '#a2d2ff'}}
          onClick={handleReplay}>
          <Image src={Volume} />
        </Flex>
        <Box
          h={{
            base: dataSpeech
              ? type === 'CAP_TU'
                ? stateGym.micAnchor?.data?.word === data?.data?.word
                  ? '120px'
                  : '0px'
                : '120px'
              : '0px',
            md: dataSpeech ? '120px' : '0px',
          }}
          transition={'height 0.2s'}
          overflow={'hidden'}>
          {dataSpeech && (
            <Flex justifyContent={'center'} my={'16px'} color={'#FFCD00'}>
              <ProgressAnt
                type="dashboard"
                size={110}
                format={percent => (
                  <Text
                    fontSize={{base: '40px', md: '48px'}}
                    color={getStrokeColor(getScore(dataSpeech?.total_score))}
                    fontWeight={700}>
                    {percent}
                  </Text>
                )}
                percent={getScore(dataSpeech?.total_score)}
                strokeColor={{
                  '0%': getStrokeColor(getScore(dataSpeech?.total_score)),
                  '100%': getStrokeColor(getScore(dataSpeech?.total_score)),
                }}
                trailColor={getTrailColor(getScore(dataSpeech?.total_score))}
              />
            </Flex>
          )}
        </Box>
        <Text
          fontSize={'30px'}
          align={'center'}
          fontWeight={700}
          color={dataSpeech ? '#BFBFBF' : ''}>
          {dataSpeech?.result
            ? dataSpeech?.result.map((w: any, index: any) => (
                <Text key={index}>
                  {w?.letters.map((ch: any, _index: any) => (
                    <Text
                      key={_index}
                      display={'inline'}
                      color={getColorCharacters(
                        w?.phones[_index],
                        data?.data?.check_ipa,
                      )}>
                      {ch.letter}
                    </Text>
                  ))}
                </Text>
              ))
            : data?.data?.word || data?.data?.content}
        </Text>
        <Text
          fontSize={'16px'}
          color={'#8C8C8C'}
          align={'center'}
          fontWeight={600}
          my={'8px'}>
          {data?.data?.word_pronoun}
        </Text>
        <Box
          h={{
            base:
              stateGym.micAnchor?.data?.word === data?.data?.word
                ? '106px'
                : type === 'CAP_TU'
                  ? '0px'
                  : '106px',

            md: 'unset',
          }}
          overflow={'hidden'}
          transition={'height 0.2s'}>
          <Text
            fontSize={'16px'}
            color={'#8C8C8C'}
            align={'center'}
            fontWeight={600}>
            {data?.data?.meaning_vn}
          </Text>
          <Flex
            bg={'#1890FF'}
            w={'80px'}
            h={'50px'}
            justifyContent={'center'}
            alignItems={'center'}
            mt={'32px'}
            borderRadius={'90px'}
            mx={'auto'}
            cursor={'pointer'}
            onClick={handleRecording}
            _hover={{
              boxShadow: '0px 0px 4px 4px #cccccc',
            }}>
            {isRecording ? (
              <Lottie animationData={animationData} />
            ) : (
              <Image src={MicIcon} cursor={'pointer'} />
            )}
          </Flex>
        </Box>
      </Box>
    </Box>
  )
}
export default MicCard
